<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tuscany</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Di gran lunga la regione vinicola più pittoresca d'Italia, la Toscana è poesia per la prosa dell'Italia meridionale. Il suo clima è perfetto: le fresche brezze del Mar Tirreno offrono un gradito sollievo nei caldi mesi estivi prima della vendemmia. Il suo terroir sabbioso-argilloso è ideale per forti,
                        vini strutturati, corposi e ricchi di colore (grazie alla percentuale di ferro nel
                        suolo). La seconda regione a produrre il più alto rapporto di D.O.C. vini (dopo il Veneto), della Toscana
                        Il Sangiovese della regione del Chianti Classico è ciò che l'ha messo sulla mappa, ed è ciò che lo mantiene
                        Là. Qualsiasi vino prodotto all'interno della santissima trinità del Chianti, Montalcino e Montepulciano può
                        portare la domanda di Sangiovese.
                        <br><br>
                        Mentre i vini Sangiovese fanno certamente parte del patrimonio nazionale dell'Italia centrale, certo esperto
                        i produttori negli anni '70 iniziarono a sperimentare Cabernet e Merlot e crearono il Super
                        Toscana. Estremamente popolare che tu sia un investitore o un appassionato, i vini Super Tuscan
                        portare l'I.G.T. etichetta. Mentre alcuni (pochissimi) vini hanno uve 100% italiane, l'originale
                        le miscele sono state fatte con uve francesi - tipicamente bordolesi (o "nobili") come il Cabernet
                        Sauvignon, Merlot e Cabernet Franc. Tuttavia, non si tratta solo del rosso: vini bianchi prodotti
                        con Trebbiano (l'uva bianca più popolare d'Italia) sono apprezzati in Toscana da alcuni produttori
                        rilasciando annate straordinarie che hanno un grande appeal sia per i principali acquirenti che per l'investitore
                        mercato.
                        <br><br>
                        Con i vini toscani che negli ultimi cinque anni consecutivi (2014-2019) hanno sovraperformato il Bordeaux
                        investire nei vini toscani potrebbe non essere sempre la scelta popolare, spesso può essere quella giusta.
                        Ci teniamo particolarmente a xxxxx.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Tuscany</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Toskana ist mit Abstand die malerischste Weinbauregion Italiens und ein Gedicht der süditalienischen Prosa. Das Klima ist perfekt: Die kühlenden Brisen des Tyrrhenischen Meeres bieten in den heißen Sommermonaten vor der Ernte eine willkommene Abwechslung. Sein sandig-lehmiges Terroir ist ideal für kräftige,
                        Strukturierte Weine, die vollmundig und farbreich sind (dank des Eisenanteils im Wein).
                        Boden). Die zweite Region mit dem höchsten Anteil an D.O.C. Weine (nach Venetien), Toskana
                        Sangiovese aus der Chianti Classico-Region hat es bekannt gemacht und hält es
                        Dort. Jeder Wein, der innerhalb der Heiligen Dreifaltigkeit Chianti, Montalcino und Montepulciano hergestellt wird, kann
                        Tragen Sie die Sangiovese-Anwendung.
                        <br><br>
                        Während Sangiovese-Weine sicherlich Teil des nationalen Erbes Mittelitaliens sind, gibt es einige, die sich damit auskennen
                        In den 1970er Jahren begannen die Produzenten mit Cabernet und Merlot zu experimentieren und schufen den Super
                        Toskanisch. Supertoskanische Weine erfreuen sich sowohl bei Anlegern als auch bei Kennern großer Beliebtheit
                        Tragen Sie die I.G.T. Etikett. Während einige (sehr wenige) Weine zu 100 % aus italienischen Trauben bestehen, dem Original
                        Mischungen wurden aus französischen Trauben hergestellt – typischerweise Bordeaux- (oder „edle“) Rebsorten wie Cabernet
                        Sauvignon, Merlot und Cabernet Franc. Es geht jedoch nicht nur um die produzierten Rotweine: Weißweine
                        mit Trebbiano (Italiens beliebteste weiße Traube) sind in der Toskana bei bestimmten Produzenten beliebt
                        Wir bringen atemberaubende Jahrgänge auf den Markt, die sowohl für Hauptkäufer als auch für den Investor großen Anklang finden
                        Markt.
                        <br><br>
                        Die toskanischen Weine übertrafen in den letzten fünf Jahren in Folge (2014-2019) die Bordeaux-Weine
                        Eine Investition in toskanische Weine ist vielleicht nicht immer die beliebte Wahl, kann aber oft die richtige sein.
                        Wir sind besonders an xxxxx interessiert.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Tuscany</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        De loin la région viticole la plus pittoresque d'Italie, la Toscane est la poésie de la prose du sud de l'Italie. Son climat est parfait : les brises rafraîchissantes de la mer Tyrrhénienne offrent un répit bienvenu pendant les chauds mois d'été précédant la récolte. Son terroir argilo-sableux est idéal pour les fortes,
                        des vins structurés, corsés et riches en couleur (grâce au pourcentage de fer dans
                        sol). La deuxième région à produire le ratio le plus élevé de D.O.C. vins (après la Vénétie), la Toscane
                        Le sangiovese de la région du Chianti Classico est ce qui l'a mis sur la carte, et c'est ce qui le maintient
                        là. Tout vin produit dans la sainte trinité du Chianti, Montalcino et Montepulciano peut
                        porter l'application Sangiovese.
                        <br><br>
                        Si les vins de Sangiovese font certainement partie du patrimoine national de l'Italie centrale, certains
                        les producteurs des années 1970 se sont mis à expérimenter le Cabernet et le Merlot et ont créé le Super
                        Toscan. Excessivement populaires que vous soyez un investisseur ou un aficionado, les vins super toscans
                        porter l'I.G.T. étiqueter. Alors que certains (très peu) vins ont des raisins 100% italiens, l'original
                        des assemblages ont été réalisés avec des raisins français - typiquement des cépages bordelais (ou «nobles») tels que le cabernet
                        Sauvignon, Merlot et Cabernet Franc. Cependant, tout ne tourne pas autour du rouge : les vins blancs produits
                        avec Trebbiano (cépage blanc le plus populaire d'Italie) sont populaires en Toscane auprès de certains producteurs
                        la sortie de superbes millésimes qui ont un grand attrait pour les acheteurs principaux et l'investisseur
                        marché.
                        <br><br>
                        Avec des vins toscans surperformant Bordeaux au cours des cinq dernières années consécutives (2014-2019) tandis que
                        investir dans les vins toscans n'est peut-être pas toujours le choix populaire, mais souvent le bon.
                        Nous aimons particulièrement xxxxx.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Tuscany</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        By far the most picturesque winemaking region of Italy, Tuscany is poetry to southern Italy's prose. Its climate is perfect: the cooling breezes from the Tyrrhenian Sea offer welcome respite in the hot summer months prior to harvest. Its sandy-clay terroir is ideal for strong,
                        structured wines that are full-bodied and rich in colour (thanks to the iron percentage in the
                        soil). The second region to produce the highest ratio of D.O.C. wines (after Veneto), Tuscany’s
                        Sangiovese from the Chianti Classico region is what put it on the map, and is what keeps it
                        there. Any wine produced within the holy trinity of Chianti, Montalcino and Montepulciano can
                        carry the Sangiovese application.
                        <br><br>
                        While Sangiovese wines are certainly part of central Italy’s national heritage, certain savvy
                        producers in the 1970s took to experimenting with Cabernet and Merlot and created the Super
                        Tuscan. Exceedingly popular whether you are an investor or an aficionado, Super Tuscan wines
                        carry the I.G.T. label. Whiles some (very few) wines have 100% Italian grapes, the original
                        blends were made with French grapes - typically Bordeaux (or “noble”) varietals such as Cabernet
                        Sauvignon, Merlot and Cabernet Franc. However, it’s not all about the red: white wines produced
                        with Trebbiano (Italy’s most popular white grape) are popular in Tuscany with certain producers
                        releasing stunning vintages that have great appeal for both primary buyers and the investor
                        market.
                        <br><br>
                        With Tuscan wines outperforming Bordeaux in the last five consecutive years (2014-2019) while
                        investing in Tuscan wines might not always be the popular choice, it can often be the right one.
                        We are particularly keen on xxxxx.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tuscany",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Tuscany | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich heritage and exceptional wines of the Tuscany wine region. Immerse yourself in the rolling hills and lush vineyards, where traditional winemaking methods are combined with modern technology to produce world-class wines. Explore the variety of styles and flavors, from the bold and complex Chianti to the smooth and elegant Brunello di Montalcino. Experience the essence of Italy with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
